const validateSupportFormField = (
  field: 'name' | 'email' | 'description',
  value: string
): string => {
  if (field === 'name' && value.trim() === '') return 'Please input full name';
  if (field === 'email') {
    if (value.trim() === '') return 'Please input email';
    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value))
      return 'Please input a valid email';
  }
  if (field === 'description' && value.trim() === '')
    return 'Please input description';

  return '';
};

export default validateSupportFormField;
